import type { ReactNode } from 'react';

import { FormLabel } from '@/components/ui/form';
import { formatMasked } from '@/lib/pages/forms/helpers';

export const ReadOnlyField = ({
  value,
  label,
  height,
  orientation = 'horizontal',
  mask,
  stretch,
  wideLabel,
  inputClass,
  responsive,
  overwriteLabelWidth,
  overwriteInputWidth,
  labelClassName,
  truncate = true,
}: {
  value: ReactNode;
  label?: ReactNode;
  maxHeight?: string;
  height?: string;
  orientation?: 'horizontal' | 'vertical';
  mask?: 'currency' | 'percentage' | 'number';
  stretch?: boolean;
  wideLabel?: boolean;
  inputClass?: string;
  responsive?: boolean;
  overwriteLabelWidth?: string;
  overwriteInputWidth?: string;
  labelClassName?: string;
  truncate?: boolean;
}) => {
  return (
    <div
      className={`flex ${orientation === 'horizontal' ? 'items-center gap-4' : 'w-full flex-col'} ${responsive ? 'max-md:w-full max-md:flex-col' : ''}`}
    >
      {label ? (
        <FormLabel
          className={`${orientation === 'horizontal' ? `${overwriteLabelWidth ? overwriteLabelWidth : `${stretch ? `${wideLabel ? 'w-2/3' : 'w-1/3'}` : `${wideLabel ? 'w-2/5' : 'w-1/5'}`}`}` : 'mb-2'} font-semibold leading-[1.5rem] ${responsive ? 'max-md:w-full' : ''} ${labelClassName}`}
        >
          {label}
        </FormLabel>
      ) : null}
      <div
        // eslint-disable-next-line no-nested-ternary
        className={`${orientation === 'horizontal' ? `${overwriteInputWidth ? overwriteInputWidth : `${stretch ? `${wideLabel ? 'w-1/3' : 'w-2/3'}` : `${wideLabel ? 'w-1/5' : 'w-2/5'}`}`}` : ''} ${inputClass} min-h-10 rounded border border-[#D4D4D8] bg-brand-50 px-3 py-2 ${height ? `min-h-[${height}px]` : truncate ? 'overflow-hidden text-ellipsis whitespace-nowrap' : 'whitespace-pre-line'} ${responsive ? 'max-md:w-full' : ''}`}
        title={String(value || '')}
      >
        {formatMasked(value, mask)}
      </div>
    </div>
  );
};
